import { useContext, useEffect, useState } from 'react';
import StoreInput from '../../StoreComponents/StoreInput';
import AuthSolidButton from './components/AuthSolidButton';
import { ReactComponent as AddUser } from '../../../assets/Add_User.svg';
import { formatPhone, getPhoneNumberMasking, validatePhone } from '../../../utils/StringUtils';
import { ButtonLoadingEllipsis } from '../../StoreComponents/StoreButton';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { UserLoginContext } from './UserLoginProvider';
import { clearBrandEntity } from '../../../redux/reducers/brandEntity';
import { BrandclubTermsAndConditions } from './TermsAndConditions';
import { useTheme } from '@mui/material';
import { BRANDCLUB_BRAND_ID } from '@brandclub/common-ui';

import OTPWrapper from './OTPWrapper';

import { NumberFormatCustom } from '@/components/StoreComponents/NumberFormatCustom';
// import { BrandclubTextMessageVerbiage } from "./TextMessageVerbiage";

const ROW_SPACING = 20;

const SignIn = ({ isUpdatePhoneFlow = false }: { isUpdatePhoneFlow?: boolean }) => {
  const { send, signIn, signInError, setSignInError, submittingSignIn } = useContext(UserLoginContext);
  const appConfig = useAppSelector(({ appConfig }) => appConfig);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (appConfig?.domainConfig.brandId === BRANDCLUB_BRAND_ID) {
      dispatch(clearBrandEntity());
    }
  }, [dispatch, appConfig?.domainConfig.brandId]);

  const [phone, setPhone] = useState('');

  const theme = useTheme();

  const submit = async (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e?.preventDefault();
    const phoneNumber = formatPhone(phone, 'e164');

    signIn(phoneNumber, isUpdatePhoneFlow, (isNewUser: boolean, session: any) => {
      return send({
        type: 'MOVE_TO_VERIFY_OTP',
        cognitoSession: session,
        otpPhoneNumber: phoneNumber,
        isNewUser,
      });
    });
  };

  const clearErrors = () => {
    setSignInError('');
  };

  const isNumberValid = validatePhone(phone);

  const phoneMasking = getPhoneNumberMasking(phone || '');

  return (
    <OTPWrapper>
      <div className="auth_container">
        <AddUser
          style={{
            width: 75,
            height: 75,
            fill: theme.vars.palette.text.primary,
          }}
        />
        <div className="page_title">Enter your phone number</div>
        <div className="page_subtitle">We will text you a verification code.</div>
        <StoreInput
          errorMsg={signInError || ''}
          value={phone}
          autoFocus
          onChange={(e) => {
            const value = e.target.value;
            setPhone(value?.trim());
            clearErrors();
          }}
          slotProps={{
            input: {
              inputComponent: NumberFormatCustom as any,
              inputProps: {
                format: phoneMasking,
              },
              disableUnderline: true,
            },
          }}
          placeholder="Phone number"
          style={{ marginTop: ROW_SPACING }}
        ></StoreInput>
        <AuthSolidButton
          type="submit"
          onClick={submit}
          disabled={submittingSignIn || !isNumberValid}
          style={{ marginTop: ROW_SPACING }}
          sx={{
            [theme.breakpoints.down('sm')]: {
              maxWidth: '100%',
            },
          }}
        >
          {submittingSignIn ? (
            <>
              Submitting
              <ButtonLoadingEllipsis blue baseFontSize={16} customColor="#dcdddc" />
            </>
          ) : (
            'Continue'
          )}
        </AuthSolidButton>
        <div className="termsAgreement" style={{ maxWidth: 330, width: '100%' }}>
          <BrandclubTermsAndConditions />
        </div>
      </div>
    </OTPWrapper>
  );
};

export default SignIn;
